import { html } from 'lit';

export const iconExclamationCircle = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0ZM7.25 4.75C7.25 4.34375 7.5625 4 8 4C8.40625 4 8.75 4.34375 8.75 4.75V8.75C8.75 9.1875 8.40625 9.5 8 9.5C7.5625 9.5 7.25 9.1875 7.25 8.75V4.75ZM8 12.5C7.4375 12.5 7 12.0625 7 11.5312C7 11 7.4375 10.5625 8 10.5625C8.53125 10.5625 8.96875 11 8.96875 11.5312C8.96875 12.0625 8.53125 12.5 8 12.5Z"
      fill="currentColor"
    />
  </svg>
`;
